import React from 'react';
import PropTypes from 'prop-types';
import TargetModalFooter from 'apps/personal/components/targets-personal-target-modal-footer';
import MatchScore from 'library/components/target-match-score';
import Query from 'library/util/query';
import { resolve } from 'library/helpers/path-resolver';

class TargetWorkflowAddTargets extends React.PureComponent {
  static propTypes = {
    close: PropTypes.func.isRequired,
    targets: PropTypes.array.isRequired,
    prev: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired
  }

  state = {
    desiredTargets: [],
    targets: [],
    saving: false
  }

  componentDidMount = () => {
    this.setState({
      targets: this.props.targets,
      desiredTargets: []
    });
  }

  nextStep = () => {
    this.setState({step: this.state.step += 1});
  }

  desiredFlag = (isDesired) => {
    return isDesired == true ? 'active' : 'inactive';
  }

  desiredTarget = (targetId) => {
    return this.state.desiredTargets.indexOf(targetId) > -1;
  }

  addTarget = (targetId) => {
    const newTargetIds = this.state.desiredTargets.concat(targetId);
    return this.setState({desiredTargets: newTargetIds});
  }

  removeTarget = (targetId) => {
    const targetIds = this.state.desiredTargets.filter((tId) => {
      return tId != targetId
    });

    return this.setState({
      desiredTargets: targetIds
    });
  }

  targetMatches = () => {
    return this.state.targets.map((target, i) => {
      const desired = this.desiredTarget(target.id)

      return (
        <div className={'personal-targets-modal-match ' + this.desiredFlag(desired)} key={i}>
          <MatchScore>{target.match}</MatchScore>
          <h3>{target.name}</h3>
          {!!desired &&
            <button className='personal-target-toggle-button' onClick={()=>this.removeTarget(target.id)}>remove</button>
          }
          {!desired &&
            <button className='personal-target-toggle-button' onClick={()=>this.addTarget(target.id)}>add</button>
          }
        </div>
      )
    });
  }

  connectDesiredTargets = async (CancelToken) => {
    const connectQuery = `mutation {
      connect_target_groupings_to_connectable(ids: [${this.state.desiredTargets.toString()}], connectable_type: 'user', connectable_id: ${this.props.user.id}) {
        success
        errors
        target_groupings {
          id
          name
        }
      }
    }`;

    return await Query(connectQuery, null, {cancelToken: CancelToken});

  }

  saveAndClose = async () => {
    if (this.state.desiredTargets.length == 0) return null;
    this.setState({saving: true})

    await this.connectDesiredTargets();

    this.setState({saving: false})
    return this.props.onComplete(this.state.targets.filter(t=>(
      this.state.desiredTargets.indexOf(t.id) > -1
    )));
  }

  render() {
    return (
      <React.Fragment>
        <div className='personal-target-modal-body'>
          <div className='personal-targets-selection'>
            { this.targetMatches() }
          </div>
        </div>
        <TargetModalFooter
          current={2}
          close={this.props.close}
          prev={this.props.prev}
          next={this.saveAndClose}
          nextLabel='Confirm'
          nextSaving={this.state.saving}
        />
      </React.Fragment>
    )
  }
}

export default TargetWorkflowAddTargets;
